class Customer.ResponseTemplateGroupsFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/groups_filter']
  className: 'filter-field-container groups-filter d-flex pb-2'

  initialize: ({filter, groups, useCustomValues = false}) ->
    @intelligentFilter = filter
    @groups = groups
    @useCustomValues = useCustomValues

  render: ->
    @$el.html @template
    @_addGroupsView()
    @

  _addGroupsView: ->
    @groupsView = new Customer.Filters.ResponseTemplateGroupsView
      terms: @groups
      customerFilter: @intelligentFilterWithDescriptions()
      useCustomValues: @useCustomValues
    @$el.find('#users-group-container').append(@groupsView.render().el)

  getIntelligentGroups: ->
    intelligent_groups = @groupsView.intelligentGroups()
    intelligent_groups.main_groups = @_parseToIds(intelligent_groups.main_groups)
    intelligent_groups.secondary_groups = @_parseToIds(intelligent_groups.secondary_groups)
    intelligent_groups.excluded_groups = @_parseToIds(intelligent_groups.excluded_groups)
    intelligent_groups

  _parseToIds: (groupNames)->
    _groupNames = groupNames || []
    ids = []
    @_parseCustomValues(_groupNames, ids)
    _.each @groups, (group) ->
      if group.description in _groupNames
        ids.push group.code.toString()
    ids

  _parseCustomValues: (groupNamesOrCodes, elements) ->
    if 'allLabels' in groupNamesOrCodes
      elements.push 'allLabels'
    if 'noLabels' in groupNamesOrCodes
      elements.push 'noLabels'

  intelligentFilterWithDescriptions: ->
    groups = @intelligentFilter.intelligent_groups
    {'intelligent_groups':
      {
        'main_groups': @_parseToDescriptions(groups.main_groups),
        'secondary_groups': @_parseToDescriptions(groups.secondary_groups),
        'excluded_groups': @_parseToDescriptions(groups.excluded_groups),
        'main_groups_logic': groups.main_groups_logic,
        'secondary_groups_logic': groups.secondary_groups_logic,
        'excluded_groups_logic': groups.excluded_groups_logic,
      }
    }

  _parseToDescriptions: (groupCodes)->
    _groupCodes = groupCodes || []
    descriptions = []
    @_parseCustomValues(_groupCodes, descriptions)
    _.each @groups, (group) ->
      if group.code.toString() in _groupCodes
        descriptions.push group.description
    descriptions

  hasSelectedGroups: ->
    @groupsView.hasSelectedGroups()
